function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".stock_outline_stroke{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "stock_outline"
}, /*#__PURE__*/React.createElement("path", {
  className: "stock_outline_stroke",
  d: "M8.5,30.4c-4.8-2.8-8-7.9-8-13.9c0-8.8,7.2-16,16-16s16,7.2,16,16c0,5.9-3.2,11.1-8,13.9l0,16l-8-8l-8,8 L8.5,30.4z"
}));

var SvgStockOutline = function SvgStockOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stockOutlineIcon",
    viewBox: "-2 -2 37 51.61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStockOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stock_outline.b7b1bca7.svg";
export { ForwardRef as ReactComponent };